import React, { Component } from 'react';
import InfoCircle from '../components/css/dark/img/info-circle-solid.svg';
const { AbortController } = window;
class Claim_New extends Component {
    constructor(props) {
        super(props);
        this.state = {
            PD: '-',
            Rev: '-',
            NC: '-',
            CC: '-',
            noDataDisplay: '',
            IsDataLoaded: false,
        };

        this.abortController = null;
        this.debounceTimer = null;

    }
    componentDidUpdate(prevProp) {
        if (prevProp.data.RequestJson != this.props.data.RequestJson && this.props.data.type == "Claim_New") {
            this.fetchData_locally();
        }
    }
    componentDidMount() {
        if (this.props.data.type == "Claim_New") {
            this.fetchData_locally();
        }
    }
    componentWillUnmount() {
        if (this.abortController) {
            this.abortController.abort();
        }
    }

    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                const data = [];
                return data;
            }
        });
    }
    fetchData_locally() {
        // Cancel any previous pending request
        if (this.abortController) {
            this.abortController.abort();
        }
        // Create a new AbortController for this request
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.setState({
            IsDataLoaded: false
        });
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'requestHeader': this.props.data.RequestJson1, 'X-Browser-Url': window.location.href },
            body: this.props.data.RequestJson,
            signal //  attach abort signal here
        };
        return fetch(this.props.data.url, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                try {
                    this.setState({ PD: apidata[0].legend[0].legendValue, Rev: apidata[0].legend[1].legendValue, NC: apidata[0].legend[2].legendValue, CC: apidata[0].legend[3].legendValue });
                    if (!signal.aborted) {
                        this.setState({
                            IsDataLoaded: true,
                            noDataDisplay: 'data available'
                        });
                    }
                }
                catch (error) {
                }
            }).catch(err => {
                if (err.name === "AbortError") {
                    // Expected cancel, just ignore
                    //console.log("Fetch request aborted");
                    return;
                }
                // Unexpected error
                //console.error("Fetch error:", err);
                this.setState({
                    IsDataLoaded: true,
                    noDataDisplay: 'Error while loading data'
                });
            });
    }

    render() {
        return (
            <div className="claimSection">

                <div className="paid">
                    <div className="tool-tip-section">
                        <img className="infoCircle" src={InfoCircle} alt="InfoCircle" />
                        <span className="toolTipContent">HD claims only</span>
                    </div>
                    <span className="small">Total Claims New</span>
                    <span>{this.state.PD}</span>
                </div>

                <div className="paid">
                    <div className="tool-tip-section">
                        <img className="infoCircle" src={InfoCircle} alt="InfoCircle" />
                        <span className="toolTipContent">HD claims only</span>
                    </div>
                    <span className="small">Reversed Claims New</span>
                    <span>{this.state.Rev}</span>
                </div>

                <div className="paid">
                    <div className="tool-tip-section">
                        <img className="infoCircle" src={InfoCircle} alt="InfoCircle" />
                        <span className="toolTipContent">HD claims only</span>
                    </div>
                    <span className="small">Net Claims New</span>
                    <span>{this.state.NC}</span>
                </div>

                <div className="paid last">
                    <div className="tool-tip-section">
                        <img className="infoCircle" src={InfoCircle} alt="InfoCircle" />
                        <span className="toolTipContent">HD claims only</span>
                    </div>
                    <span className="small">Paid Claims New</span>
                    <span>{this.state.CC}</span>
                </div>


            </div>
        )
    }
}
export default Claim_New;